<style type="text/css">
    [data-aos] {
        opacity: 1 !important;
        transform: translate(0) scale(1) !important;
    }
</style>

<body id="top">
    <div class="page-content">
        <div class="container">

            <div class="cover shadow-lg p-lg-4 " style="margin-top: 50px; padding-bottom: 0!important;">

                <!-- Dev Part Begins Here -->
                <div class="cover-dev">
                    <div class="row">

                        <div class="text-center text-md-start">
                            <p data-aos="fade-left" data-aos-delay="100"><br></p>
                            <h2 class="h1 mb-3" data-aos="fade-left" data-aos-delay="0" align="center"
                                style="color:white">Coding<br></h2>

                            <div class="d-print-none" data-aos="fade-left" data-aos-delay="200">
                                <br>
                            </div>
                            <p data-aos="fade-left" data-aos-delay="100"><br> <br></p>
                        </div>
                    </div>
                </div>
                <div class="about-section pt-4 px-3 px-lg-4 mt-1" id="Logistics_Company">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Management and control of stores
                                <span class="text-muted h5"> for Amazon LLC</span>
                                <span class="text-muted h6" style="font-size: 50%"> [</span>
                                <span class="text-muted h6">Desktop application</span>
                                <span class="text-muted h6" style="font-size: 50%">]</span>
                            </div>

                            <div align="center" class="row">
                                <video width="auto" height="auto" controls controlsList="nodownload">
                                    <source src="/assets/videos/Logistics_Company.mp4" type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;">The
                                figure below shows the
                                logo of our platform, we chose to use the colors of the
                                Instagram and Twitter logos whose platform provides a targeted service to users of
                                these social networks, also the abbreviation of the project name and An for
                                analysis, I for Instagram,
                                T for Twitter and finally IT is the English abbreviation for 'Information
                                Technology'.
                            </p>
                        </div>
                        <div class="h6 mb-1">Client Review</div>
                        <img src="/assets/images/portfolio/reviews_dev/Logistics_Company.PNG" class="client-review">

                    </div>
                </div>
                <hr class="d-print-none" />

                <div class="about-section pt-4 px-3 px-lg-4 mt-1" id="trency">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Decision support for investment
                                <span class="text-muted h5"> for Confidential</span>
                                <span class="text-muted h6" style="font-size: 50%"> [</span>
                                <span class="text-muted h6">Web Platform</span>
                                <span class="text-muted h6" style="font-size: 50%">]</span>
                            </div>


                            <ngb-carousel *ngIf="trency_images" class="text-lg-center">
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="trency_images[0]" alt="Random first slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                    <!--  
                                        <div class="carousel-caption">
                                        <h3>10 seconds between slides...</h3>
                                        <p>This carousel uses customized default values.</p>
                                    </div>
                                    -->
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="trency_images[1]" alt="Random second slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="trency_images[2]" alt="Random third slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>

                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="trency_images[3]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>

                                </ng-template>


                            </ngb-carousel>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;">The
                                figure below shows the
                                logo of our platform, we chose to use the colors of the
                                Instagram and Twitter logos whose platform provides a targeted service to users of
                                these social networks, also the abbreviation of the project name and An for
                                analysis, I for Instagram,
                                T for Twitter and finally IT is the English abbreviation for 'Information
                                Technology'.
                            </p>
                        </div>
                    </div>
                </div>

                <hr class="d-print-none" />

                <div class="about-section pt-4 px-3 px-lg-4 mt-1" id="Terrainet">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Management of private sports fields
                                <span class="text-muted h5"> as an Academic Project</span>
                                <span class="text-muted h6" style="font-size: 50%"> [</span>
                                <span class="text-muted h6">Web, Mobile & Desktop</span>
                                <span class="text-muted h6" style="font-size: 50%">]</span>
                            </div>


                            <ngb-carousel *ngIf="terrainet_images" class="text-lg-center">
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[0]" alt="Random first slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[1]" alt="Random second slide"
                                            style="height: 100%; width: 110%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[2]" alt="Random third slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[3]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[4]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[5]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[6]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[7]" alt="Random fourth slide"
                                            style="height: 100%; width: 100%; object-fit: contain">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[8]" alt="Random fourth slide">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[9]" alt="Random fourth slide">
                                    </div>
                                </ng-template>
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img [src]="terrainet_images[10]" alt="Random fourth slide">
                                    </div>
                                </ng-template>


                            </ngb-carousel>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;">
                                The carousel above shows 3 types of interfaces: Desktop, Web and Mobile #only the
                                features that I've worked on out of respect for the effort that the team members done as
                                I didn't ask for permission to share their work#, the platform mainly was made of
                                <b>manage</b>
                                private sport fields, for the <i>OWNERS</i> and the <i>PLAYERS</i>, interfaces for the
                                owner (admin) was built to help him track time management with a nice calendar to get to
                                know what time slots that he made was reserved already, some statistics too to help him
                                track his fields evolution, rush hours and so on; and for the players, interfaces to
                                reserve time slots, confirm their attendency, fill the team members forms, get the exact
                                field place with a map, etc.
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="d-print-none" />


                <!-- Dev Part Ends Here -->

                <!-- Design Part Begins Here -->
                <div class="cover-design">
                    <div class="row">

                        <div class="text-center text-md-start">
                            <p data-aos="fade-left" data-aos-delay="100"><br></p>
                            <h2 class="h1 mb-3" data-aos="fade-left" data-aos-delay="0" align="center"
                                style="color:white">Design<br></h2>

                            <div class="d-print-none" data-aos="fade-left" data-aos-delay="200">
                                <br>
                            </div>
                            <p data-aos="fade-left" data-aos-delay="100"><br> <br></p>
                        </div>
                    </div>
                </div>
                <div class="about-section pt-4 px-3 px-lg-4 mt-1">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Trency<span class="text-muted h6"> Logo</span></div>

                            <div align="center"><img src="/assets/images/portfolio/design/logo_trency.png"
                                    class="img-fluid" width="400" height="200" alt="logo_anit"
                                    style="border-radius: 10px"></div>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word;">The figure above shows the logo of
                                our platform which is minimal and simple since this is the trend.

                                The magnifying glass that contains a charter exposes the idea that our project gives a
                                plus to other projects that are based just on the display of price evolution charts.

                                The name of our project is composed of two parts: Tr + ency
                                -“Tr” is for “Trading” and it’s the stock and investment game,
                                -”ency” is for “Currency”, and that’s the currency.

                                Finally, we chose color degradation to highlight the idea of evolution and orange color
                                to give dynamic and fast impression.

                            </p>
                        </div>

                    </div>
                </div>
                <hr class="d-print-none" />
                <div class="about-section pt-4 px-3 px-lg-4 mt-1">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Anit<span class="text-muted h6"> Logo</span></div>

                            <div align="center"><img src="/assets/images/portfolio/design/logo_anit.png"
                                    class="img-fluid" width="200" height="200" alt="logo_anit"></div>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;">The
                                figure below shows the
                                logo made for my Graduation Project, I chose to use the colors of the
                                Instagram and Twitter logos whose platform provides a targeted service to users of
                                these social networks, also the abbreviation of the project name and An for
                                analysis, I for Instagram,
                                T for Twitter and finally IT is the English abbreviation for 'Information
                                Technology'.
                            </p>
                        </div>

                    </div>
                </div>
                <hr class="d-print-none" />

                <div class="about-section pt-4 px-3 px-lg-4 mt-1">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">DataSense<span class="text-muted h6"> Logo</span></div>

                            <div align="center"><img src="/assets/images/portfolio/design/logo_datasense.png"
                                    class="img-fluid" width="400" height="200" alt="logo_anit"></div>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;">The
                                figure below shows the
                                logo of our platform, we chose to use the colors of the
                                Instagram and Twitter logos whose platform provides a targeted service to users of
                                these social networks, also the abbreviation of the project name and An for
                                analysis, I for Instagram,
                                T for Twitter and finally IT is the English abbreviation for 'Information
                                Technology'.
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="d-print-none" />

                <!-- Business Card Begins Here-->
                <div class="about-section pt-4 px-3 px-lg-4 mt-1 mb-4">
                    <div class="row">
                        <div class="">
                            <div class="h4 mb-1">Advocate<span class="text-muted h6"> Business Card</span></div>

                            <div align="center"><img src="/assets/images/portfolio/design/business_card_front.png"
                                    class="img-fluid" width="500" alt="business_card_front"></div>
                            <div class="h4 mb-1" align="center"><span class="text-muted h5">Front Face</span></div>
                            <br>

                            <div align="center"><img src="/assets/images/portfolio/design/business_card_back.png"
                                    class="img-fluid" width="500" alt="business_card_back"></div>
                            <div class="h4 mb-1" align="center"><span class="text-muted h5">Back Face</span></div>
                            <br>

                            <p style="text-align: justify; text-justify: inter-word; margin-bottom:0px !important;"
                                class="pb-2">
                                As you can see the business card is made for the best lawyer ever 'My Father', I tried
                                to make it Classy, Clean And Clear for clients whatever their age, background, region
                                and gender are.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Business Card Ends Here-->

                <script src="/assets/2nd/scripts/bootstrap.bundle.min.js?ver=1.2.0"></script>
                <script src="/assets/2nd/scripts/aos.js?ver=1.2.0"></script>
                <script src="/assets/2nd/scripts/main.js?ver=1.2.0"></script>
                <script src="/assets/scripts/imagesloaded.pkgd.min.js?ver=1.1.0"></script>
                <script src="/assets/scripts/masonry.pkgd.min.js?ver=1.1.0"></script>
                <script src="/assets/scripts/bootstrap.bundle.min.js?ver=1.1.0"></script>
                <script src="/assets/scripts/aos.js?ver=1.1.0"></script>
                <script src="/assets/scripts/main.js?ver=1.1.0"></script>
                <script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
                    integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
                    crossorigin="anonymous"></script>
            </div>
        </div>
    </div>
</body>